import { onMounted, ref, watch } from '@vue/composition-api';

const useSlides = (indexValue, root, emit) => {
  const { data, videos } = root;
  const currentSlide = data.slides[indexValue];
  const isLoading = ref(false);

  onMounted(() => {
    emit('on-slide-data', currentSlide);

    if (currentSlide.component !== 'Slide0') {
      if (videos.find((video) => video.id === currentSlide.video.id)) return;
      isLoading.value = true;
    }
  });

  watch(
    videos,
    (newCurrentVideos) => {
      const currentVideo = newCurrentVideos.find(
        (video) => video.id === currentSlide.video.id,
      );
      if (currentVideo) {
        isLoading.value = false;
      }
    },
    { immediate: true, deep: true },
  );

  const onNextSlide = () => {
    emit('on-next-slide');
  };

  return { currentSlide, isLoading, onNextSlide };
};

export default useSlides;
